import { render, staticRenderFns } from "./BudgetPageHeader.vue?vue&type=template&id=a3ecf7f8&scoped=true"
import script from "./BudgetPageHeader.vue?vue&type=script&lang=js"
export * from "./BudgetPageHeader.vue?vue&type=script&lang=js"
import style0 from "./BudgetPageHeader.vue?vue&type=style&index=0&id=a3ecf7f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ecf7f8",
  null
  
)

export default component.exports